<template>
  <div class="item-base " v-if="CaseItem">
    <div class="item-img">
      <el-image :src="'http://'+ CaseItem.address" class="img"></el-image>
    </div>
    <div class="item-title">
      <span>{{CaseItem.description}}</span>
    </div>
    <div class="item-time">
<!--      <span @click="handleEnter(CaseItem.id)">查看更多 <i class="el-icon-arrow-right"></i></span>-->
<!--      <span>{{CaseItem.eventTime | Date}}</span>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: "HomeCaseItem",
    props:{
      CaseItem:{

      }
    },
    filters:{
      Date(value){
      const date= new Date(value);
      const Mou=date.getMonth()+1
      return Mou+'-'+date.getDate()

    }
     },
    methods:{
      handleEnter(id){
        this.$router.push('/case/detail/'+id)
      }
    }
  }
</script>

<style lang="less" scoped>
  .item-base{
    width: 30%;
    min-height: 440px;
    .item-img{
      width: 100%;
      height: 312px;
      overflow: hidden;
      .img{
        width: 100%;
        height: 312px;
        border-radius: 2px;
        object-fit: cover;
        transition: all 0.6s ease;
        &:hover{
          transform: scale(1.1);
        }
      }
    }
    .item-title{
      width: 100%;
      margin-top: 10px;
      height: 56px;
      overflow: hidden;
      text-align: left;
      span{
        display: flex;
        font-size: 20px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 28px;
        text-indent: 5px;
      }
    }
    .item-time{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      span{
        &:first-child{
          i{
            font-size: 14px;
          }
          &:hover{
            color: #188ACB;
          }
        }
        display: block;
        //width: 85px;
        height: 16px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #999999;
        line-height: 24px;

      }
    }
  }
</style>